import httpClient from "../../api/httpClient";
import Parceiro from "../classes/Parceiro";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "Parceiro/All" },
  { method: "GET", rota: "Parceiro" },
  { method: "GET", rota: "Parceiro/Grupo/{Grupo}" }, // Foi alterado no App. Tem que alterar na API
  { method: "POST", rota: "Parceiro/Adicionar" },
  { method: "PUT", rota: "Parceiro/Atualizar" },
  { method: "GET" , rota:"Parceiro/Count"},
  { method: "GET", rota:"Parceiro/AllWithBlocked"},
  { method: "DELETE", rota:"Parceiro/Bloquear"},
  { method: "DELETE", rota:"Parceiro/Desbloquear"},
  { method: "GET", rota:"Parceiro/Filtrar"},
  //     {method: "GET",  rota:"​/Parceiro​/TreeParceiros"}, //Suspenso por enquando.
];

const cacheKey: string = "ParceiroCache";
const cacheKeySelC: string = "ParceiroSelecionado";
const cacheKeySelI: string = "IdParceiroSelecionado";
const cacheKeySelG: string = "GrupoParceiroSelecionado";
const cacheKeySelCFS: string = "CodigoFornecedorSAPSelecionado";
                                
const apiServico: String = "PORTAL"

class ParceiroDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }
  async Adicionar(value: Parceiro) {
    return await super.post(calls[3].rota, value);
  }

  async ObterPorId(id: number) {
    return await super.Get(`${calls[1].rota}/${id}`);
  }

  async Atualizar(value: Parceiro) {
    return await super.put(calls[4].rota, value);
  }

  async Bloquear(value: Parceiro) {
    let ok: boolean = false;    
    return await super.delete(calls[7].rota, value);
  }

  Desbloquear(value: Parceiro) {
    let ok: boolean = false;
    let error: any = undefined;
    super.delete(calls[8].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  async ListarAtivos(): Promise<Parceiro[]> {
    return await super.Get(calls[0].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async ListarAtivosPorUsuario(id: number): Promise<Parceiro[]> {
    return await super.Get(`${calls[0].rota}/${id}`)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async ListarTodos(filter: string): Promise<Parceiro[]> {
    return await super.Get(`${calls[9].rota}?filter=${filter}`)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async ListarQuantidadeDeParceiro(): Promise<number> {
    return await super.Get(calls[5].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  getKeyCachId(): string {
    return cacheKeySelI;
  }

  getKeyCachGrupo(): string {
    return cacheKeySelG;
  }

  getKeyCachCodigoFornecedor() : string {
    return cacheKeySelCFS;
  }

  ListarFromCache(): Parceiro[] {
    let result: Parceiro[] = JSON.parse(String(localStorage.getItem(cacheKey)));
    return result;
  }

  AdicionarListaAoCache(value: Parceiro[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  AdicionarObjetoAoCache(value: Parceiro) {
    localStorage.setItem(cacheKeySelC, JSON.stringify(value));
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }

  AdicionarIdAoCache(value: number) {
    localStorage.setItem(cacheKeySelI, JSON.stringify(value));
  }

  LimparIdDoCache() {
    localStorage.removeItem(cacheKeySelI);
  }

  AdicionarGrupoAoCache(value: string) {
    localStorage.setItem(cacheKeySelG, value);
  }

  LimparGrupoDoCache() {
    localStorage.removeItem(cacheKeySelG);
  }

  AdicionarCodigoFornecedorSapAoCache(value: number) {
    localStorage.setItem(cacheKeySelCFS, JSON.stringify(value));
  }

  LimparCodigoFornecedorSapDoCache() {
    localStorage.removeItem(cacheKeySelCFS);
  }

}
export default ParceiroDataset;

